import {Component, Input, OnChanges, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {EmailSettingService} from '@services/email-setting.service';
import {LoaderService} from '@services/loader.service';
import {ToastrService} from 'ngx-toastr';
import {Observable} from 'rxjs';

@Component({
    selector: 'app-add-update-email-setting',
    templateUrl: './add-update-email-setting.component.html',
    styleUrl: './add-update-email-setting.component.scss'
})
export class AddUpdateEmailSettingComponent implements OnInit, OnChanges {
    @Input() emailSettingId: number = 0;
    form!: FormGroup;
    title!: string;
    loading = false;
    sendTestMailVisible: boolean = false;
    submitting = false;
    submitted = false;
    public isAuthLoading = false;
    isLoading$: Observable<boolean>;
    constructor(
        private emailSettingService: EmailSettingService,
        private formBuilder: FormBuilder,
        private toastr: ToastrService,
        private loaderService: LoaderService
    ) {
        this.isLoading$ = this.loaderService.isLoading$;
        this.form = this.formBuilder.group({
            id: [0],
            email: [
                null,
                [
                    Validators.required,
                    Validators.pattern(
                        '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$'
                    )
                ]
            ],
            host: [null, [Validators.required]],
            userName: [
                null,
                [
                    Validators.required,
                    Validators.pattern(
                        '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$'
                    )
                ]
            ],
            password: [null, [Validators.required]],
            port: [null, [Validators.required]],
            enableSSl: [false],
            defaultEmail: [false]
            // password and confirm password only required in add mode
        });
    }
    ngOnInit() {}
    ngOnChanges() {
        if (!!this.emailSettingId && this.emailSettingId != 0) {
            this.emailSettingService
                .getEmailSettingById(this.emailSettingId)
                .subscribe((data) => {
                    this.form.patchValue(data);
                });
        } else {
            this.form.reset();
        }
    }
    get f() {
        return this.form.controls;
    }
    onSubmit() {
        this.loaderService.showLoader();
        this.isAuthLoading = true;
        this.submitted = true;
        if (this.form.invalid) {
            return;
        }
        if (!!this.emailSettingId && this.emailSettingId != 0) {
            this.emailSettingService
                .updateEmailSetting(this.form.value)
                .subscribe((result) => {
                    setTimeout(() => {
                        this.isAuthLoading = false;
                        this.loaderService.hideLoader();
                        this.toastr.success('Updated Successfully');
                    }, 2000);
                });
        } else {
            //set default value if null
            const formValue = {...this.form.value};
            if (formValue.id === null) {
                formValue.id = 0;
            }
            if (formValue.defaultEmail == null) {
                formValue.defaultEmail = false;
            }
            if (formValue.enableSSl == null) {
                formValue.enableSSl = false;
            }
            this.emailSettingService
                .createEmailSettings(formValue)
                .subscribe((result) => {
                    setTimeout(() => {
                        this.isAuthLoading = false;
                        this.loaderService.hideLoader();
                        this.toastr.success('Added Successfully !!');
                    }, 2000);
                });
        }
    }
    showDialog() {
        this.sendTestMailVisible = true;
    }
}
